// // // // workflowApi.js
// // // // Drop into the same folder as your other epms components
// // // // (alongside adminEpmsPermission.jsx, staffDocsEpmsModal.jsx, etc.)
// // // import api from '../../../api/axiosInterceptor';

// // // // ── Stage constants — must match apps/excess_payment_mgmt/models (ExcessMaster) ──
// // // export const STAGES = {
// // //   PENDING_CASE_WORKER: 'pending_case_worker',
// // //   PENDING_FORENSIC_AUDITOR: 'pending_forensic_auditor',
// // //   PENDING_SHIRASTEDAR: 'pending_shirastedar',
// // //   PENDING_TAHSILDAR: 'pending_tahsildar',
// // //   PENDING_AC: 'pending_ac',
// // //   PENDING_CA_SPLOCA: 'pending_ca_sploca',
// // //   PENDING_PAYMENT: 'pending_payment',
// // //   CLOSED: 'closed',
// // // };

// // // export const STAGE_LABELS = {
// // //   [STAGES.PENDING_CASE_WORKER]: 'Pending Case Worker',
// // //   [STAGES.PENDING_FORENSIC_AUDITOR]: 'Pending Forensic Auditor',
// // //   [STAGES.PENDING_SHIRASTEDAR]: 'Pending Shirastedar',
// // //   [STAGES.PENDING_TAHSILDAR]: 'Pending Tahsildar',
// // //   [STAGES.PENDING_AC]: 'Pending Assistant Commissioner',
// // //   [STAGES.PENDING_CA_SPLOCA]: 'Pending Competent Authority / SPLOCA',
// // //   [STAGES.PENDING_PAYMENT]: 'Pending Payment Processing',
// // //   [STAGES.CLOSED]: 'Closed',
// // // };

// // // export const STAGE_COLORS = {
// // //   [STAGES.PENDING_CASE_WORKER]: 'default',
// // //   [STAGES.PENDING_FORENSIC_AUDITOR]: 'secondary',
// // //   [STAGES.PENDING_SHIRASTEDAR]: 'info',
// // //   [STAGES.PENDING_TAHSILDAR]: 'info',
// // //   [STAGES.PENDING_AC]: 'warning',
// // //   [STAGES.PENDING_CA_SPLOCA]: 'warning',
// // //   [STAGES.PENDING_PAYMENT]: 'primary',
// // //   [STAGES.CLOSED]: 'success',
// // // };

// // // // ── Role normalization — mirrors CASE_WORKER_ROLE_ALIASES on the backend ──
// // // const CASE_WORKER_ALIASES = new Set(['case_worker', 'super_staff', 'staff']);

// // // export const normalizeRole = (rawRole) => {
// // //   if (!rawRole) return rawRole;
// // //   return CASE_WORKER_ALIASES.has(rawRole) ? 'case_worker' : rawRole;
// // // };

// // // // Fallback if this app ever needs the role outside a component (no hooks available).
// // // // Prefer `useSelector(s => s.auth.role)` inside components — this is a backup only.
// // // export const getRoleFromCookie = () => {
// // //   const match = document.cookie.match(/(?:^|;\s*)user_role=([^;]*)/);
// // //   return match ? decodeURIComponent(match[1]) : null;
// // // };

// // // // ── API calls ──────────────────────────────────────────────────────────────
// // // export const fetchMyQueue = () =>
// // //   api.get('/excess_payment_mgmt/workflow/my-queue/');

// // // export const fetchWorkflowHistory = (excessId) =>
// // //   api.get(`/excess_payment_mgmt/workflow/history/${excessId}/`);

// // // export const submitCaseWorkerDecision = (excessId, { decision, remarks }) =>
// // //   api.post(`/excess_payment_mgmt/workflow/case-worker-decision/${excessId}/`, {
// // //     decision,
// // //     remarks,
// // //   });

// // // export const submitForensicAuditorAction = (excessId, formData) =>
// // //   api.post(
// // //     `/excess_payment_mgmt/workflow/forensic-auditor-action/${excessId}/`,
// // //     formData,
// // //     { headers: { 'Content-Type': 'multipart/form-data' } }
// // //   );

// // // export const submitForwardReturn = (excessId, { actionType, remarks, newCaseWorkerId }) =>
// // //   api.post(`/excess_payment_mgmt/workflow/forward-return/${excessId}/`, {
// // //     action_type: actionType,
// // //     remarks,
// // //     ...(newCaseWorkerId ? { new_case_worker_id: newCaseWorkerId } : {}),
// // //   });

// // // // Roles that use the generic forward/return dialog (everything except
// // // // Case Worker's initial decision and the Forensic Auditor's report action,
// // // // which each have their own dedicated dialog).
// // // export const GENERIC_FORWARD_RETURN_ROLES = new Set([
// // //   'shirastedar',
// // //   'tahsildar',
// // //   'assistant_commissioner',
// // //   'competent_authority',
// // //   'sploca',
// // // ]);


// // // workflowApi.js
// // // Drop into the same folder as your other epms components
// // // (alongside adminEpmsPermission.jsx, staffDocsEpmsModal.jsx, etc.)
// // import api from '../../../api/axiosInterceptor';

// // // ── Stage constants — must match apps/excess_payment_mgmt/models (ExcessMaster) ──
// // export const STAGES = {
// //   PENDING_CASE_WORKER: 'pending_case_worker',
// //   PENDING_FORENSIC_AUDITOR: 'pending_forensic_auditor',
// //   PENDING_SHIRASTEDAR: 'pending_shirastedar',
// //   PENDING_TAHSILDAR: 'pending_tahsildar',
// //   PENDING_AC: 'pending_ac',
// //   PENDING_CA: 'pending_ca',
// //   PENDING_SPLOCA: 'pending_sploca',
// //   PENDING_PAYMENT: 'pending_payment',
// //   CLOSED: 'closed',
// // };

// // export const STAGE_LABELS = {
// //   [STAGES.PENDING_CASE_WORKER]: 'Pending Case Worker',
// //   [STAGES.PENDING_FORENSIC_AUDITOR]: 'Pending Forensic Auditor',
// //   [STAGES.PENDING_SHIRASTEDAR]: 'Pending Shirastedar',
// //   [STAGES.PENDING_TAHSILDAR]: 'Pending Tahsildar',
// //   [STAGES.PENDING_AC]: 'Pending Assistant Commissioner',
// //   [STAGES.PENDING_CA]: 'Pending Competent Authority',
// //   [STAGES.PENDING_SPLOCA]: 'Pending SPLOCA (Final Approval)',
// //   [STAGES.PENDING_PAYMENT]: 'Pending Payment Processing',
// //   [STAGES.CLOSED]: 'Closed',
// // };

// // export const STAGE_COLORS = {
// //   [STAGES.PENDING_CASE_WORKER]: 'default',
// //   [STAGES.PENDING_FORENSIC_AUDITOR]: 'secondary',
// //   [STAGES.PENDING_SHIRASTEDAR]: 'info',
// //   [STAGES.PENDING_TAHSILDAR]: 'info',
// //   [STAGES.PENDING_AC]: 'warning',
// //   [STAGES.PENDING_CA]: 'warning',
// //   [STAGES.PENDING_SPLOCA]: 'warning',
// //   [STAGES.PENDING_PAYMENT]: 'primary',
// //   [STAGES.CLOSED]: 'success',
// // };

// // export const WORKFLOW_LABELS = {
// //   workflow_1: 'Workflow 1 — Full Agreement (Lump Sum)',
// //   workflow_2: 'Workflow 2 — Forensic Auditor Route',
// // };

// // // Order Status dropdown choices — matches the model's commented choices
// // // ("waiting" / "Delivered" / "Returned to office").
// // export const DELIVERY_STATUS_OPTIONS = ['waiting', 'Delivered', 'Returned to office'];

// // // ── Role normalization — mirrors CASE_WORKER_ROLE_ALIASES on the backend ──
// // const CASE_WORKER_ALIASES = new Set(['case_worker', 'super_staff', 'staff']);

// // export const normalizeRole = (rawRole) => {
// //   if (!rawRole) return rawRole;
// //   return CASE_WORKER_ALIASES.has(rawRole) ? 'case_worker' : rawRole;
// // };

// // // Fallback if this app ever needs the role outside a component (no hooks available).
// // // Prefer `useSelector(s => s.auth.role)` inside components — this is a backup only.
// // export const getRoleFromCookie = () => {
// //   const match = document.cookie.match(/(?:^|;\s*)user_role=([^;]*)/);
// //   return match ? decodeURIComponent(match[1]) : null;
// // };

// // // ── API calls ──────────────────────────────────────────────────────────────
// // export const fetchMyQueue = () =>
// //   api.get('/excess_payment_mgmt/workflow/my-queue/');

// // export const fetchMyRecords = () =>
// //   api.get('/excess_payment_mgmt/workflow/my-records/');

// // export const fetchWorkflowHistory = (excessId) =>
// //   api.get(`/excess_payment_mgmt/workflow/history/${excessId}/`);

// // // Readiness + preview — call before showing the "Submit" button so the Case
// // // Worker sees exactly what's missing and which workflow it will route to.
// // export const fetchCaseWorkerReadiness = (excessId) =>
// //   api.get(`/excess_payment_mgmt/workflow/case-worker-readiness/${excessId}/`);

// // // Confirms submission — no manual workflow choice anymore, it's auto-routed
// // // server-side from Docs + Order Status + Payment/installment data.
// // export const submitCaseWorkerDecision = (excessId, { remarks } = {}) =>
// //   api.post(`/excess_payment_mgmt/workflow/case-worker-decision/${excessId}/`, { remarks });

// // export const submitForensicAuditorAction = (excessId, formData) =>
// //   api.post(
// //     `/excess_payment_mgmt/workflow/forensic-auditor-action/${excessId}/`,
// //     formData,
// //     { headers: { 'Content-Type': 'multipart/form-data' } }
// //   );

// // export const submitForwardReturn = (excessId, { actionType, remarks, newCaseWorkerId }) =>
// //   api.post(`/excess_payment_mgmt/workflow/forward-return/${excessId}/`, {
// //     action_type: actionType,
// //     remarks,
// //     ...(newCaseWorkerId ? { new_case_worker_id: newCaseWorkerId } : {}),
// //   });

// // // Roles that use the generic forward/return dialog (everything except
// // // Case Worker's submission and the Forensic Auditor's report action, which
// // // each have their own dedicated dialog).
// // export const GENERIC_FORWARD_RETURN_ROLES = new Set([
// //   'shirastedar',
// //   'tahsildar',
// //   'assistant_commissioner',
// //   'competent_authority',
// //   'sploca',
// // ]);



// // workflowApi.js
// // Drop into the same folder as your other epms components
// // (alongside adminEpmsPermission.jsx, staffDocsEpmsModal.jsx, etc.)
// import api from '../../../api/axiosInterceptor';

// // ── Stage constants — must match apps/excess_payment_mgmt/models (ExcessMaster) ──
// export const STAGES = {
//   PENDING_CASE_WORKER: 'pending_case_worker',
//   PENDING_FORENSIC_AUDITOR: 'pending_forensic_auditor',
//   PENDING_SHIRASTEDAR: 'pending_shirastedar',
//   PENDING_TAHSILDAR: 'pending_tahsildar',
//   PENDING_AC: 'pending_ac',
//   PENDING_CA: 'pending_ca',
//   PENDING_SPLOCA: 'pending_sploca',
//   PENDING_PAYMENT: 'pending_payment',
//   CLOSED: 'closed',
// };

// export const STAGE_LABELS = {
//   [STAGES.PENDING_CASE_WORKER]: 'Pending Case Worker',
//   [STAGES.PENDING_FORENSIC_AUDITOR]: 'Pending Forensic Auditor',
//   [STAGES.PENDING_SHIRASTEDAR]: 'Pending Shirastedar',
//   [STAGES.PENDING_TAHSILDAR]: 'Pending Tahsildar',
//   [STAGES.PENDING_AC]: 'Pending Assistant Commissioner',
//   [STAGES.PENDING_CA]: 'Pending Competent Authority',
//   [STAGES.PENDING_SPLOCA]: 'Pending SPLOCA (Final Approval)',
//   [STAGES.PENDING_PAYMENT]: 'Pending Payment Processing',
//   [STAGES.CLOSED]: 'Closed',
// };

// export const STAGE_COLORS = {
//   [STAGES.PENDING_CASE_WORKER]: 'default',
//   [STAGES.PENDING_FORENSIC_AUDITOR]: 'secondary',
//   [STAGES.PENDING_SHIRASTEDAR]: 'info',
//   [STAGES.PENDING_TAHSILDAR]: 'info',
//   [STAGES.PENDING_AC]: 'warning',
//   [STAGES.PENDING_CA]: 'warning',
//   [STAGES.PENDING_SPLOCA]: 'warning',
//   [STAGES.PENDING_PAYMENT]: 'primary',
//   [STAGES.CLOSED]: 'success',
// };

// export const WORKFLOW_LABELS = {
//   workflow_1: 'Workflow 1 — Full Agreement (Lump Sum)',
//   workflow_2: 'Workflow 2 — Forensic Auditor Route',
// };

// // Order Status dropdown choices — matches the model's commented choices
// // ("waiting" / "Delivered" / "Returned to office"). Note: for the Case
// // Worker's readiness check, only "Delivered" counts as ready — "waiting"
// // AND "Returned to office" both block submission.
// export const DELIVERY_STATUS_OPTIONS = ['waiting', 'Delivered', 'Returned to office'];

// // Document upload size limits — matches DocsStatusAPIView.
// export const MAX_DOC_FILE_SIZE = 2 * 1024 * 1024; // 2 MB — Address Proof, PAN, Aadhar, Affidavit
// export const MAX_BANK_STATEMENT_FILE_SIZE = 10 * 1024 * 1024; // 10 MB — statements are often multi-page

// // ── Role normalization — mirrors CASE_WORKER_ROLE_ALIASES on the backend ──
// const CASE_WORKER_ALIASES = new Set(['case_worker', 'super_staff', 'staff']);

// export const normalizeRole = (rawRole) => {
//   if (!rawRole) return rawRole;
//   return CASE_WORKER_ALIASES.has(rawRole) ? 'case_worker' : rawRole;
// };

// // Fallback if this app ever needs the role outside a component (no hooks available).
// // Prefer `useSelector(s => s.auth.role)` inside components — this is a backup only.
// export const getRoleFromCookie = () => {
//   const match = document.cookie.match(/(?:^|;\s*)user_role=([^;]*)/);
//   return match ? decodeURIComponent(match[1]) : null;
// };

// // ── API calls ──────────────────────────────────────────────────────────────

// // options: { stage, onlyReturned, excludeReturned, feId }
// export const fetchMyQueue = (options = {}) => {
//   const params = new URLSearchParams();
//   if (options.stage) params.append('stage', options.stage);
//   if (options.onlyReturned) params.append('only_returned', 'true');
//   if (options.excludeReturned) params.append('exclude_returned', 'true');
//   if (options.feId) params.append('fe_id', options.feId);
//   const qs = params.toString();
//   return api.get(`/excess_payment_mgmt/workflow/my-queue/${qs ? `?${qs}` : ''}`);
// };

// // options: { feId }
// export const fetchMyRecords = (options = {}) => {
//   const params = new URLSearchParams();
//   if (options.feId) params.append('fe_id', options.feId);
//   const qs = params.toString();
//   return api.get(`/excess_payment_mgmt/workflow/my-records/${qs ? `?${qs}` : ''}`);
// };

// // FE options for the FE-filter dropdown (Competent Authority / SPLOCA).
// export const fetchMyFeList = () =>
//   api.get('/excess_payment_mgmt/workflow/my-fe-list/');

// export const fetchWorkflowHistory = (excessId) =>
//   api.get(`/excess_payment_mgmt/workflow/history/${excessId}/`);

// // Readiness + preview — call before showing the "Submit" button so the Case
// // Worker sees exactly what's missing and which workflow it will route to.
// export const fetchCaseWorkerReadiness = (excessId) =>
//   api.get(`/excess_payment_mgmt/workflow/case-worker-readiness/${excessId}/`);

// // Confirms submission — no manual workflow choice anymore, it's auto-routed
// // server-side from Docs + Order Status + Payment/installment data.
// export const submitCaseWorkerDecision = (excessId, { remarks } = {}) =>
//   api.post(`/excess_payment_mgmt/workflow/case-worker-decision/${excessId}/`, { remarks });

// export const submitForensicAuditorAction = (excessId, formData) =>
//   api.post(
//     `/excess_payment_mgmt/workflow/forensic-auditor-action/${excessId}/`,
//     formData,
//     { headers: { 'Content-Type': 'multipart/form-data' } }
//   );

// export const submitForwardReturn = (excessId, { actionType, remarks, newCaseWorkerId }) =>
//   api.post(`/excess_payment_mgmt/workflow/forward-return/${excessId}/`, {
//     action_type: actionType,
//     remarks,
//     ...(newCaseWorkerId ? { new_case_worker_id: newCaseWorkerId } : {}),
//   });

// // Roles that use the generic forward/return dialog (everything except
// // Case Worker's submission and the Forensic Auditor's report action, which
// // each have their own dedicated dialog).
// export const GENERIC_FORWARD_RETURN_ROLES = new Set([
//   'shirastedar',
//   'tahsildar',
//   'assistant_commissioner',
//   'competent_authority',
//   'sploca',
// ]);
// workflowApi.js
// Drop into the same folder as your other epms components
// (alongside adminEpmsPermission.jsx, staffDocsEpmsModal.jsx, etc.)
// import api from '../../../api/axiosInterceptor';

// // ── Stage constants — must match apps/excess_payment_mgmt/models (ExcessMaster) ──
// export const STAGES = {
//   PENDING_CASE_WORKER: 'pending_case_worker',
//   PENDING_FORENSIC_AUDITOR: 'pending_forensic_auditor',
//   PENDING_SHIRASTEDAR: 'pending_shirastedar',
//   PENDING_TAHSILDAR: 'pending_tahsildar',
//   PENDING_AC: 'pending_ac',
//   PENDING_CA: 'pending_ca',
//   PENDING_SPLOCA: 'pending_sploca',
//   PENDING_PAYMENT: 'pending_payment',
//   CLOSED: 'closed',
// };

// export const STAGE_LABELS = {
//   [STAGES.PENDING_CASE_WORKER]: 'Pending Case Worker',
//   [STAGES.PENDING_FORENSIC_AUDITOR]: 'Pending Forensic Auditor',
//   [STAGES.PENDING_SHIRASTEDAR]: 'Pending Shirastedar',
//   [STAGES.PENDING_TAHSILDAR]: 'Pending Tahsildar',
//   [STAGES.PENDING_AC]: 'Pending Assistant Commissioner',
//   [STAGES.PENDING_CA]: 'Pending Competent Authority',
//   [STAGES.PENDING_SPLOCA]: 'Pending SPLOCA (Final Approval)',
//   [STAGES.PENDING_PAYMENT]: 'Pending Payment Processing',
//   [STAGES.CLOSED]: 'Closed',
// };

// export const STAGE_COLORS = {
//   [STAGES.PENDING_CASE_WORKER]: 'default',
//   [STAGES.PENDING_FORENSIC_AUDITOR]: 'secondary',
//   [STAGES.PENDING_SHIRASTEDAR]: 'info',
//   [STAGES.PENDING_TAHSILDAR]: 'info',
//   [STAGES.PENDING_AC]: 'warning',
//   [STAGES.PENDING_CA]: 'warning',
//   [STAGES.PENDING_SPLOCA]: 'warning',
//   [STAGES.PENDING_PAYMENT]: 'primary',
//   [STAGES.CLOSED]: 'success',
// };

// export const WORKFLOW_LABELS = {
//   workflow_1: 'Workflow 1 — Full Agreement (Lump Sum)',
//   workflow_2: 'Workflow 2 — Forensic Auditor Route',
// };

// // Order Status dropdown choices — matches the model's commented choices
// // ("waiting" / "Delivered" / "Returned to office"). Note: for the Case
// // Worker's readiness check, only "Delivered" counts as ready — "waiting"
// // AND "Returned to office" both block submission.
// export const DELIVERY_STATUS_OPTIONS = ['waiting', 'Delivered', 'Returned to office'];

// // Document upload size limits — matches DocsStatusAPIView.
// export const MAX_DOC_FILE_SIZE = 2 * 1024 * 1024; // 2 MB — Address Proof, PAN, Aadhar, Affidavit
// export const MAX_BANK_STATEMENT_FILE_SIZE = 10 * 1024 * 1024; // 10 MB — statements are often multi-page

// // Installment "Paid By" method — selecting "Others" reveals a free-text
// // field whose value gets stored directly in the same `payment_method` key.
// export const PAYMENT_METHOD_OPTIONS = ['UPI', 'Cheque', 'Cash', 'NEFT/RTGS', 'Others'];

// // Per-installment payment statement/receipt upload limit — matches
// // InstallmentMasterAPIView.
// export const MAX_INSTALLMENT_STATEMENT_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

// // ── Role normalization — mirrors CASE_WORKER_ROLE_ALIASES on the backend ──
// const CASE_WORKER_ALIASES = new Set(['case_worker', 'super_staff', 'staff']);

// export const normalizeRole = (rawRole) => {
//   if (!rawRole) return rawRole;
//   return CASE_WORKER_ALIASES.has(rawRole) ? 'case_worker' : rawRole;
// };

// // Fallback if this app ever needs the role outside a component (no hooks available).
// // Prefer `useSelector(s => s.auth.role)` inside components — this is a backup only.
// export const getRoleFromCookie = () => {
//   const match = document.cookie.match(/(?:^|;\s*)user_role=([^;]*)/);
//   return match ? decodeURIComponent(match[1]) : null;
// };

// // ── API calls ──────────────────────────────────────────────────────────────

// // options: { stage, onlyReturned, excludeReturned, feId }
// export const fetchMyQueue = (options = {}) => {
//   const params = new URLSearchParams();
//   if (options.stage) params.append('stage', options.stage);
//   if (options.onlyReturned) params.append('only_returned', 'true');
//   if (options.excludeReturned) params.append('exclude_returned', 'true');
//   if (options.feId) params.append('fe_id', options.feId);
//   const qs = params.toString();
//   return api.get(`/excess_payment_mgmt/workflow/my-queue/${qs ? `?${qs}` : ''}`);
// };

// // options: { feId }
// export const fetchMyRecords = (options = {}) => {
//   const params = new URLSearchParams();
//   if (options.feId) params.append('fe_id', options.feId);
//   const qs = params.toString();
//   return api.get(`/excess_payment_mgmt/workflow/my-records/${qs ? `?${qs}` : ''}`);
// };

// // FE options for the FE-filter dropdown (Competent Authority / SPLOCA).
// export const fetchMyFeList = () =>
//   api.get('/excess_payment_mgmt/workflow/my-fe-list/');

// export const fetchWorkflowHistory = (excessId) =>
//   api.get(`/excess_payment_mgmt/workflow/history/${excessId}/`);

// // Readiness + preview — call before showing the "Submit" button so the Case
// // Worker sees exactly what's missing and which workflow it will route to.
// export const fetchCaseWorkerReadiness = (excessId) =>
//   api.get(`/excess_payment_mgmt/workflow/case-worker-readiness/${excessId}/`);

// // Confirms submission — no manual workflow choice anymore, it's auto-routed
// // server-side from Docs + Order Status + Payment/installment data.
// export const submitCaseWorkerDecision = (excessId, { remarks } = {}) =>
//   api.post(`/excess_payment_mgmt/workflow/case-worker-decision/${excessId}/`, { remarks });

// export const submitForensicAuditorAction = (excessId, formData) =>
//   api.post(
//     `/excess_payment_mgmt/workflow/forensic-auditor-action/${excessId}/`,
//     formData,
//     { headers: { 'Content-Type': 'multipart/form-data' } }
//   );

// export const submitForwardReturn = (excessId, { actionType, remarks, newCaseWorkerId }) =>
//   api.post(`/excess_payment_mgmt/workflow/forward-return/${excessId}/`, {
//     action_type: actionType,
//     remarks,
//     ...(newCaseWorkerId ? { new_case_worker_id: newCaseWorkerId } : {}),
//   });

// // Roles that use the generic forward/return dialog (everything except
// // Case Worker's submission and the Forensic Auditor's report action, which
// // each have their own dedicated dialog).
// export const GENERIC_FORWARD_RETURN_ROLES = new Set([
//   'shirastedar',
//   'tahsildar',
//   'assistant_commissioner',
//   'competent_authority',
//   'sploca',
// ]);


// workflowApi.js
// Drop into the same folder as your other epms components
// (alongside adminEpmsPermission.jsx, staffDocsEpmsModal.jsx, etc.)
import api from '../../../api/axiosInterceptor';

// ── Stage constants — must match apps/excess_payment_mgmt/models (ExcessMaster) ──
export const STAGES = {
  PENDING_CASE_WORKER: 'pending_case_worker',
  PENDING_FORENSIC_AUDITOR: 'pending_forensic_auditor',
  PENDING_SHIRASTEDAR: 'pending_shirastedar',
  PENDING_TAHSILDAR: 'pending_tahsildar',
  PENDING_AC: 'pending_ac',
  PENDING_JOINT_SECRETARY: 'pending_joint_secretary',  
  PENDING_CA: 'pending_ca',
  PENDING_SPLOCA: 'pending_sploca',
  PENDING_PAYMENT: 'pending_payment',
  CLOSED: 'closed',
};

export const STAGE_LABELS = {
  [STAGES.PENDING_CASE_WORKER]: 'Pending Case Worker',
  [STAGES.PENDING_FORENSIC_AUDITOR]: 'Pending Forensic Auditor',
  [STAGES.PENDING_SHIRASTEDAR]: 'Pending Shirastedar',
  [STAGES.PENDING_TAHSILDAR]: 'Pending Tahsildar',
  [STAGES.PENDING_AC]: 'Pending Assistant Commissioner',
  [STAGES.PENDING_JOINT_SECRETARY]: 'Pending Joint Secretary',
  [STAGES.PENDING_CA]: 'Pending Competent Authority',
  [STAGES.PENDING_SPLOCA]: 'Pending SPLOCA (Final Approval)',
  [STAGES.PENDING_PAYMENT]: 'Pending Payment Processing',
  [STAGES.CLOSED]: 'Closed',
};

export const STAGE_COLORS = {
  [STAGES.PENDING_CASE_WORKER]: 'default',
  [STAGES.PENDING_FORENSIC_AUDITOR]: 'secondary',
  [STAGES.PENDING_SHIRASTEDAR]: 'info',
  [STAGES.PENDING_TAHSILDAR]: 'info',
  [STAGES.PENDING_AC]: 'warning',
  [STAGES.PENDING_JOINT_SECRETARY]: 'warning',
  [STAGES.PENDING_CA]: 'warning',
  [STAGES.PENDING_SPLOCA]: 'warning',
  [STAGES.PENDING_PAYMENT]: 'primary',
  [STAGES.CLOSED]: 'success',
};

export const WORKFLOW_LABELS = {
  workflow_1: 'Workflow 1 — Full Agreement (Lump Sum)',
  workflow_2: 'Workflow 2 — Forensic Auditor Route',
};

// Order Status dropdown choices — matches the model's commented choices
// ("waiting" / "Delivered" / "Returned to office"). Note: for the Case
// Worker's readiness check, only "Delivered" counts as ready — "waiting"
// AND "Returned to office" both block submission.
export const DELIVERY_STATUS_OPTIONS = ['waiting', 'Delivered', 'Returned to office'];

// Document upload size limits — matches DocsStatusAPIView.
export const MAX_DOC_FILE_SIZE = 2 * 1024 * 1024; // 2 MB — Address Proof, PAN, Aadhar, Affidavit
export const MAX_BANK_STATEMENT_FILE_SIZE = 10 * 1024 * 1024; // 10 MB — statements are often multi-page

// Installment "Paid By" method — selecting "Others" reveals a free-text
// field whose value gets stored directly in the same `payment_method` key.
export const PAYMENT_METHOD_OPTIONS = ['UPI', 'Cheque', 'Cash', 'NEFT/RTGS', 'Others'];

// Per-installment payment statement/receipt upload limit — matches
// InstallmentMasterAPIView.
export const MAX_INSTALLMENT_STATEMENT_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

// ── Role normalization — mirrors CASE_WORKER_ROLE_ALIASES on the backend ──
const CASE_WORKER_ALIASES = new Set(['case_worker', 'super_staff', 'staff']);

export const normalizeRole = (rawRole) => {
  if (!rawRole) return rawRole;
  return CASE_WORKER_ALIASES.has(rawRole) ? 'case_worker' : rawRole;
};

// Fallback if this app ever needs the role outside a component (no hooks available).
// Prefer `useSelector(s => s.auth.role)` inside components — this is a backup only.
export const getRoleFromCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)user_role=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

// ── API calls ──────────────────────────────────────────────────────────────

// options: { stage, onlyReturned, excludeReturned, feId }
export const fetchMyQueue = (options = {}) => {
  const params = new URLSearchParams();
  if (options.stage) params.append('stage', options.stage);
  if (options.onlyReturned) params.append('only_returned', 'true');
  if (options.excludeReturned) params.append('exclude_returned', 'true');
  if (options.feId) params.append('fe_id', options.feId);
  const qs = params.toString();
  return api.get(`/excess_payment_mgmt/workflow/my-queue/${qs ? `?${qs}` : ''}`);
};

// options: { feId }
export const fetchMyRecords = (options = {}) => {
  const params = new URLSearchParams();
  if (options.feId) params.append('fe_id', options.feId);
  const qs = params.toString();
  return api.get(`/excess_payment_mgmt/workflow/my-records/${qs ? `?${qs}` : ''}`);
};

// FE options for the FE-filter dropdown (Competent Authority / SPLOCA).
export const fetchMyFeList = () =>
  api.get('/excess_payment_mgmt/workflow/my-fe-list/');

// Shirastedar options for the SHR dropdown — optionally scoped to one FE.
export const fetchMyShrList = (feId) => {
  const qs = feId ? `?fe_id=${feId}` : '';
  return api.get(`/excess_payment_mgmt/workflow/my-shirastedar-list/${qs}`);
};

export const fetchWorkflowHistory = (excessId) =>
  api.get(`/excess_payment_mgmt/workflow/history/${excessId}/`);

// Readiness + preview — call before showing the "Submit" button so the Case
// Worker sees exactly what's missing and which workflow it will route to.
export const fetchCaseWorkerReadiness = (excessId) =>
  api.get(`/excess_payment_mgmt/workflow/case-worker-readiness/${excessId}/`);

// Confirms submission — no manual workflow choice anymore, it's auto-routed
// server-side from Docs + Order Status + Payment/installment data.
export const submitCaseWorkerDecision = (excessId, { remarks } = {}) =>
  api.post(`/excess_payment_mgmt/workflow/case-worker-decision/${excessId}/`, { remarks });

export const submitForensicAuditorAction = (excessId, formData) =>
  api.post(
    `/excess_payment_mgmt/workflow/forensic-auditor-action/${excessId}/`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );

export const submitForwardReturn = (excessId, { actionType, remarks, newCaseWorkerId }) =>
  api.post(`/excess_payment_mgmt/workflow/forward-return/${excessId}/`, {
    action_type: actionType,
    remarks,
    ...(newCaseWorkerId ? { new_case_worker_id: newCaseWorkerId } : {}),
  });

// Roles that use the generic forward/return dialog (everything except
// Case Worker's submission and the Forensic Auditor's report action, which
// each have their own dedicated dialog).
export const GENERIC_FORWARD_RETURN_ROLES = new Set([
  'shirastedar',
  'tahsildar',
  'assistant_commissioner',
  'joint_secretary',
  'competent_authority',
  'sploca',
]);